import React from "react";
import TableStructure from "./tableStructure";
import styles from "../../../styles/myAccount/myDocuments.module.scss";

function DocumentWrapper({
  year,
  labels,
  heading,
  data,
  headers,
  targetValue,
  linkText,
  headingText,
}) {
  const id = heading?.replace(/[^\w]/g, "");
  var filteredData = null;
  if (data !== null) {
    filteredData = data.filter((d) => d.date.indexOf(year) >= 0);
  }

  return (
    <div className={styles["tru-mma-main-content-box"]}>
      <a
        data-toggle="collapse"
        href={`#${id}`}
        role="button"
        aria-expanded="false"
        aria-controls={id}
        className={styles["tru-mma-main-service-header"]}
      >
        {heading}
      </a>
      {(!filteredData || ( filteredData !== null && filteredData.length === 0 ))&& (
        <div
          id={id}
          aria-expanded="true"
          className={styles["tru-mma-main-service-box"]}
        >
          <span
            className="d-block gfs-20 gfs-lg-28 gfw-3 text-center"
            style={{ visibility: "visible" }}
          >
            {labels.noDocsMessage}
          </span>
        </div>
      )}
      {filteredData !== null && filteredData.length > 0 && (
        <TableStructure
          labels={labels}
          data={filteredData}
          headers={headers}
          id={id}
          heading={heading}
          targetValue={targetValue}
          linkText={linkText}
          textForHeading={headingText}
        />
      )}
    </div>
  );
}
export default DocumentWrapper;
